import type { FinanceRate } from '@kanda-libs/ks-frontend-services';

import {
  CLASS_NAMES as BASE_CLASS_NAME,
  type QuoteClassNames,
} from '../../constants';

export const FINANCE_OPTIONS: FinanceRate[] = [
  {
    apr: 1190,
    apr_type: 'INTEREST_BEARING',
    charge: 0,
    credit_line: 500000,
    deferred_duration: 0,
    duration: 12,
    enabled: true,
    fee: 400,
    finance_types: ['primary'],
    max_deposit_pct: 5000,
    max_deposit_value: 0,
    max_job_value: 1500000,
    min_charge: 2800,
    min_deposit_pct: 0,
    min_deposit_value: 0,
    min_job_value: 25000,
    name: 'INTEREST_BEARING_12_1190',
    provider: 'etika',
    work_types: [],
  },
  {
    apr: 1190,
    apr_type: 'INTEREST_BEARING',
    charge: 0,
    credit_line: 500000,
    deferred_duration: 0,
    duration: 18,
    enabled: true,
    fee: 400,
    finance_types: ['primary'],
    max_deposit_pct: 5000,
    max_deposit_value: 0,
    max_job_value: 1500000,
    min_charge: 2800,
    min_deposit_pct: 0,
    min_deposit_value: 0,
    min_job_value: 25000,
    name: 'INTEREST_BEARING_18_1190',
    provider: 'etika',
    work_types: [],
  },
  {
    apr: 1190,
    apr_type: 'INTEREST_BEARING',
    charge: 0,
    credit_line: 500000,
    deferred_duration: 0,
    duration: 24,
    enabled: true,
    fee: 400,
    finance_types: ['primary'],
    max_deposit_pct: 5000,
    max_deposit_value: 0,
    max_job_value: 1500000,
    min_charge: 2800,
    min_deposit_pct: 0,
    min_deposit_value: 0,
    min_job_value: 25000,
    name: 'INTEREST_BEARING_24_1190',
    provider: 'etika',
    work_types: [],
  },
  {
    apr: 1190,
    apr_type: 'INTEREST_BEARING',
    charge: 0,
    credit_line: 500000,
    deferred_duration: 0,
    duration: 36,
    enabled: true,
    fee: 400,
    finance_types: ['primary'],
    max_deposit_pct: 5000,
    max_deposit_value: 0,
    max_job_value: 1500000,
    min_charge: 2800,
    min_deposit_pct: 0,
    min_deposit_value: 0,
    min_job_value: 25000,
    name: 'INTEREST_BEARING_36_1190',
    provider: 'etika',
    work_types: [],
  },
  {
    apr: 1190,
    apr_type: 'INTEREST_BEARING',
    charge: 0,
    credit_line: 500000,
    deferred_duration: 0,
    duration: 48,
    enabled: true,
    fee: 400,
    finance_types: ['primary'],
    max_deposit_pct: 5000,
    max_deposit_value: 0,
    max_job_value: 1500000,
    min_charge: 2800,
    min_deposit_pct: 0,
    min_deposit_value: 0,
    min_job_value: 25000,
    name: 'INTEREST_BEARING_48_1190',
    provider: 'etika',
    work_types: [],
  },
  {
    apr: 1190,
    apr_type: 'INTEREST_BEARING',
    charge: 0,
    credit_line: 500000,
    deferred_duration: 0,
    duration: 60,
    enabled: true,
    fee: 400,
    finance_types: ['primary'],
    max_deposit_pct: 5000,
    max_deposit_value: 0,
    max_job_value: 1900000,
    min_charge: 2800,
    min_deposit_pct: 0,
    min_deposit_value: 0,
    min_job_value: 200000,
    name: 'INTEREST_BEARING_60_1190',
    provider: 'etika',
    work_types: [],
  },
];

export interface CreditLineClassNames {
  card: string;
  wrapper: string;
  item: string;
  skeletonWrapper: string;
  heading: string;
  pounds: string;
  cents: string;
  duration: string;
}

export const CREDIT_LINE_CLASS_NAMES: CreditLineClassNames = {
  card: 'flex flex-row relative w-full ml-4 mt-4 border rounded-lg p-3 md:p-4 shadow-card cursor-pointer',
  wrapper: 'flex flex-row w-1/2',
  item: 'flex flex-col first:mr-4 text-left',
  skeletonWrapper: 'w-full ml-4 mt-4',
  heading: 'text-10-17-em-up text-neutral-600',
  pounds: 'text-14-22-em md:text-16-20-em',
  cents: 'text-12-18-em',
  duration: 'text-14-22-em md:text-16-20-em text-purple-400',
};

export interface IndicatorClassNames {
  container: string;
  tick: string;
}

export const INDICATOR_CLASS_NAMES: IndicatorClassNames = {
  container:
    'absolute bottom-2 right-2 md:top-4 md:right-4 flex w-5 h-5 rounded-full border',
  tick: 'mx-auto mt-0.75 w-1.5 h-2.5 border-r-2 border-b-2 rotate-45 border-neutral-000',
};

export interface CreditLinesClassNames extends QuoteClassNames {
  itemWrapper: string;
}

export const CLASS_NAMES: CreditLinesClassNames = {
  ...BASE_CLASS_NAME,
  itemWrapper: 'flex flex-row flex-wrap -ml-4 -mt-4',
};
